import { createSlice } from '@reduxjs/toolkit';
import { loginAsync } from './thunks';

const initialState = {
  isLoading: false,
  error: '',
  isAuthenticated: false,
  user: {},
  proxy: {
    isProxy: false,
    data: {},
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    setProxyUser: (state, action) => {
      const data = action.payload;

      state.proxy.isProxy = true;
      state.proxy.data = data || {};
    },
    removeProxyUser: (state, action) => {
      state.proxy.isProxy = false;
      state.proxy.data = {};
    },
    logout: (state, action) => {
      state.isAuthenticated = false;
      state.user = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state, action) => {
        state.isLoading = true;
        state.error = '';
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.user = {};
        state.error = action.error.message;
      });
  },
});

export const { setToken, logout, setProxyUser, removeProxyUser } =
  authSlice.actions;

export default authSlice.reducer;
